export const SINGLE_ELIGIBLE_PLAN_PROMOTION_TEXT =
  'Add another eligible plan to save 20%';
export const NO_ELIGIBLE_PLAN_PROMOTION_TEXT =
  'Add 2 eligible plans to save 20%';
